const validatePageIsConnectable = async (editorSdkProxy, pageRefToConvert) => {
  const validPages = await editorSdkProxy.routers.pages.listConnectablePages()
  const isRequiredPageValid = validPages.some(
    page => page.pageRef.id === pageRefToConvert.id,
  )
  if (!isRequiredPageValid) {
    throw new Error(
      `The given page ${JSON.stringify(pageRefToConvert)} cannot be converted`,
    )
  }
}

export default async ({ editorSdkProxy, pageRef, origin, appApi }) => {
  await validatePageIsConnectable(editorSdkProxy, pageRef)
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line prefer-const
    let token
    const listener = payload => {
      if (payload?.error) {
        reject(payload.error)
      } else {
        resolve(payload?.pageRefs)
      }
      appApi.removeListener('pageConversionEnded', token)
    }
    token = appApi.addListener('pageConversionEnded', listener)

    appApi.openConvertToDynamicPagePanelV2({ pageRef, origin }).catch(err => {
      reject(err)
    })
  })
}
